import React from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { connect } from 'react-redux';
import { Input, Select, FallbackImage, Render, Button, Table, Pagination, Modal } from 'components';
import { RootState } from 'reducers';
import { Globals, Constants } from 'utils';
import { AssistantService } from 'services';
import ModalView from './view';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

const INITIAL_STATE = {
	search: ''
}

class Assistants extends React.Component<Props> {

	timer: any = undefined;

	state = {
		header: [
			'Item',
			'Nombre',
			'Email',
			'Teléfono',
			'Ciudad',
			'Cédula',
			'¿Ayudante activo?',
			'Opciones'
		],
		form: INITIAL_STATE,
		data: [],
		page: 1,
		last_page: 1,
		visible: false,
		item: null
	}

	componentDidMount() {
		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Ayudantes',
				onBack: null
			}
		});

		this.props.dispatch({
			type: 'SET_SUBHEADER',
			payload: {
				title: ''
			}
		});

		this.load();
	}

	load = async (withoutLoading = false) => {
		const res: any = await AssistantService.get({
			withoutLoading,
			page: this.state.page,
			...this.state.form
		});
		this.setState({
			data: res.assistants?.rows?.map((item: any, index: number) => {
				item._index = (this.state.page - 1) * Constants.PER_PAGE + (index + 1)
				return item;
			}) || [],
			last_page: res.assistants?.count || 1
		});
	}

	change = (e: any,callback = () => {}) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		},callback);
	}

	delete = (item: any) => {
		Globals.confirm('¿Desea eliminar el ayudante?',async () => {
			await AssistantService.delete({
				assistant_id: item.id
			});
			this.load(true);
		});
	}

	changeStatus = (item: any) => {
		Globals.confirm('¿Desea cambiar de estatus al ayudante?',async () => {
			await AssistantService.changeStatus({
				assistant_id: item.id
			});
			this.load(true);
		});
	}

	onClose = () => {
		this.setState({
			visible: false
		});
	}

	view = (item: any) => {
		this.setState({
			visible: true,
			item
		});
	}

	render() {
		const { visible } = this.state;

		return (
			<div id="assistants">
				<Modal
		          className="modal-view-assistant"
		          visible={ visible }
		          title="Detalles"
		          onClose={ () => this.onClose() }
		        >
		        	{/*
		        	// @ts-ignore */}
		        	<ModalView
		        		item={ this.state.item }
		        	/>
		      	</Modal>

				<div className="row row-white">
					<div className="col-md-6">
						<p className="title-white">Usuarios</p>
					</div>
					<div className="col-md-6">
						<div className="container-add">
							<Input
								value={ this.state.form.search }
								name="search"
								placeholder="Buscar"
								className="input-table"
								notMui
								searchRight
								onChange={ (e: any) => {
									clearTimeout(this.timer);
									this.timer = setTimeout(() => {
										this.load(true);
									},1000);
									this.change(e); 
								} } />
							<button className="btn" onClick={ () => this.props.history.push(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/assistants/create`) }>
								<p>Registrar Ayudante</p>
								<div className="add">
									+
								</div>
							</button>
						</div>
					</div>
				</div>

				<Table title="Ayudantes" data={ this.state.data.length } header={ this.state.header }>
					{ this.state.data.map((i: any,index: number) => {
						return (
							<tr key={ index }>
								<td>{ i._index }</td>
								<td>{ i.name } { i.lastname }</td>
								<td>{ i.email }</td>
								<td>{ i.phone }</td>
								<td>{ i.city }</td>
								<td>{ i.nationality?.code }{ i.document }</td>
								<td>
									<div className="check-container">
										<div className={ `check ${ i.status == Constants.ASSISTANT_STATUS.ACTIVE ? 'active' : '' }` } onClick={ () => this.changeStatus(i) }>
											<div className="check-circle"></div>
										</div>
										<p className="label-status">{ i.status_text }</p>
									</div>
								</td>
								<td>
									<button className="btn btn-update" onClick={ () => this.view(i) }>
										Detalles
									</button>
									<button className="btn btn-delete" onClick={ () => this.delete(i) }>
										Eliminar
									</button>
									<button className="btn btn-transparent" onClick={ () => this.props.history.push(`/${ this.props.user?.level_id == Constants.LEVELS.CLIENT ? 'client' : 'moderators' }/assistants/create/` + i.id) }>
										Editar
									</button>
								</td>
							</tr>
						)
					}) }
				</Table>

				<Pagination 
					pages={ this.state.last_page } 
					active={ this.state.page }
					onChange={ async (page: number) => {
						await this.setState({
							page: page
						});
						this.load();
					} } />
			</div>
		)
	}
}

export default connect((state: RootState) => {
	return {
		user: state.user
	}
})(Assistants);